import script from "./BlogDetailBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogDetailBanner.vue?vue&type=script&setup=true&lang=js"

import "./BlogDetailBanner.vue?vue&type=style&index=0&id=20237a1c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20237a1c"]])

export default __exports__